import type { LevelConfig } from '../index';

export const level3: LevelConfig = {
  id: 'level_3',
  stage: '1',
  mapId: 'map_03',
  timeLimitSec: 160,
  playerSpawn: { x: 160, y: 160 },
  objective: { type: 'activate_terminals', target: 2 },
  enemies: [
    {
      type: 'BASIC_SCAMMER',
      position: { x: 300, y: 300 },
      patrolPath: [
        { x: 300, y: 300 },
        { x: 300, y: 500 },
        { x: 150, y: 500 },
        { x: 150, y: 300 },
      ],
    },
    {
      type: 'BASIC_SCAMMER',
      position: { x: 750, y: 350 },
      patrolPath: [
        { x: 750, y: 350 },
        { x: 750, y: 500 },
        { x: 830, y: 500 },
        { x: 830, y: 350 },
      ],
    },
    {
      type: 'SUPPORT_SCAMMER',
      position: { x: 500, y: 800 },
      patrolPath: [
        { x: 500, y: 800 },
        { x: 500, y: 870 },
        { x: 350, y: 870 },
        { x: 350, y: 800 },
      ],
    },
  ],
  loot: [
    { type: 'COIN', position: { x: 300, y: 300 }, value: 10 },
    { type: 'COIN', position: { x: 500, y: 300 }, value: 10 },
    { type: 'COIN', position: { x: 700, y: 300 }, value: 10 },
    { type: 'COIN', position: { x: 300, y: 500 }, value: 10 },
    { type: 'COIN', position: { x: 500, y: 500 }, value: 10 },
    { type: 'COIN', position: { x: 700, y: 500 }, value: 10 },
    { type: 'COIN', position: { x: 300, y: 700 }, value: 10 },
    { type: 'COIN', position: { x: 500, y: 700 }, value: 10 },
    { type: 'COIN', position: { x: 700, y: 700 }, value: 10 },
    { type: 'COIN', position: { x: 400, y: 850 }, value: 10 },
    { type: 'COIN', position: { x: 600, y: 850 }, value: 10 },
    { type: 'COIN', position: { x: 800, y: 850 }, value: 10 },
  ],
  startingWeapon: null,
  startingAmmo: 0,
  unlocks: [],
};
